import React from 'react';
import { Box, CircularProgress } from '@mui/material';

const DatagridLoader: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <CircularProgress size={32} />
    </Box>
  );
};

export default DatagridLoader;
